/** Evaluates a catalog formula without importing room, floor or device models. */
export function evalExpression(expression: string, context: Record<string, number>) {
  const names = Object.keys(context);
  const values = Object.values(context);
  const fn = new Function(...names, `return (${expression});`);
  return fn(...values);
}
